// @flow
import React from 'react'
import { Alert } from '@paypalcorp/pp-react-alert'
import content from 'pp-react-l10n'

let i18n = content('transfer/inc/openBanking')

type Props = {
  contentKey: string,
  style: Object,
  accountType: ?string,
}

const OpenBankingWarning = (props: Props) => {
  const { contentKey, style, accountType } = props

  return (
    <Alert
      type="attention"
      style={{
        margin: 0,
        ...style,
      }}
      data-testid="funding-option-warning"
    >
      {i18n(contentKey, { accountType })}
    </Alert>
  )
}

export default OpenBankingWarning
